import script from "./CrudBoletos.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudBoletos.vue?vue&type=script&setup=true&lang=js"

import "./CrudBoletos.vue?vue&type=style&index=0&id=3f6b76db&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f6b76db"]])

export default __exports__